import React, { memo } from 'react';
import { Divider } from '@redlink/components/atoms';
import { InnerLinkChildItem } from '@redlink/components/muscles';

export const InnerLinkList = memo(({ data }) => {
  return (
    <>
      {data.map((item) => (
        <>
          <Divider margin={5} />
          <InnerLinkChildItem {...{ item }} />
        </>
      ))}
    </>
  );
});
